import * as types from './mutation-types';
import lifecyclesService from '../../services/lifecycles'
import { createServiceCall } from '../actionsUtil'

export const getLifecyclePlatforms = createServiceCall({
  mainAction: types.GET_LIFECYCLES_PLATFORMS_REQUEST,
  serviceFunction: lifecyclesService.getLifecyclePlatforms,
  successAction: types.GET_LIFECYCLES_PLATFORMS_SUCCESS,
  successDataProperty: "getLifecyclePlatforms",
  failureAction: types.GET_LIFECYCLES_PLATFORMS_FAILURE
});

export const getLifecycleTasks = createServiceCall({
  mainAction: types.GET_LIFECYLCE_TASKS_REQUEST,
  serviceFunction: lifecyclesService.getLifecycleTasks,
  successAction: types.GET_LIFECYLCE_TASKS_SUCCESS,
  failureAction: types.GET_LIFECYLCE_TASKS_FAILURE
});

export const getLifecycleTasksForUser = createServiceCall({
  mainAction: types.GET_LIFECYLCE_TASKS_FOR_USER_REQUEST,
  serviceFunction: lifecyclesService.getLifecycleTasksForUser,
  successAction: types.GET_LIFECYLCE_TASKS_FOR_USER_SUCCESS,
  failureAction: types.GET_LIFECYLCE_TASKS_FOR_USER_FAILURE
});

export const createTaskComment = createServiceCall({
  mainAction: types.CREATE_TASK_COMMENT_REQUEST,
  serviceFunction: lifecyclesService.createTaskComment,
  successAction: types.CREATE_TASK_COMMENT_SUCCESS,
  failureAction: types.CREATE_TASK_COMMENT_FAILURE
});

export const removeTaskComment = createServiceCall({
  mainAction: types.REMOVE_TASK_COMMENT_REQUEST,
  serviceFunction: lifecyclesService.removeTaskComment,
  successAction: types.REMOVE_TASK_COMMENT_SUCCESS,
  failureAction: types.REMOVE_TASK_COMMENT_FAILURE
});

export const editTaskComment = createServiceCall({
  mainAction: types.EDIT_TASK_COMMENT_REQUEST,
  serviceFunction: lifecyclesService.editTaskComment,
  successAction: types.EDIT_TASK_COMMENT_SUCCESS,
  failureAction: types.EDIT_TASK_COMMENT_FAILURE
});

export const getTaskTypes = createServiceCall({
  mainAction: types.GET_TASK_TYPES_REQUEST,
  serviceFunction: lifecyclesService.getTaskTypes,
  successAction: types.GET_TASK_TYPES_SUCCESS,
  failureAction: types.GET_TASK_TYPES_FAILURE
});

export const createTask = createServiceCall({
  mainAction: types.CREATE_TASK_REQUEST,
  serviceFunction: lifecyclesService.createTask,
  successAction: types.CREATE_TASK_SUCCESS,
  failureAction: types.CREATE_TASK_FAILURE
});

export const deleteTask = createServiceCall({
  mainAction: types.DELETE_TASK_REQUEST,
  serviceFunction: lifecyclesService.deleteTask,
  successAction: types.DELETE_TASK_SUCCESS,
  failureAction: types.DELETE_TASK_FAILURE
});

export const editTask = createServiceCall({
  mainAction: types.EDIT_TASK_REQUEST,
  serviceFunction: lifecyclesService.editTask,
  successAction: types.EDIT_TASK_SUCCESS,
  failureAction: types.EDIT_TASK_FAILURE
});

export const setLifecyclePlatforms = ({commit}) => {
  commit(types.SET_LIFECYCLE_PLATFORMS)
}
